import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  MotifModalModule,
  MotifButtonModule,
  MotifIconModule,
  MOTIF_MODAL_DATA,
} from '@ey-xd/ng-motif';
import {
  TranslatePipe,
  TranslateDirective,
  TranslateService,
} from '@ngx-translate/core';
import { ResumeData } from '../../../models/dialogData';
import { IconoirInfoCircle } from '@ey-xd/motif-icon';

@Component({
  selector: 'timeout-dialog',
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    MotifModalModule,
    MotifButtonModule,
    MotifIconModule,
  ],
  templateUrl: './timeout-dialog.component.html',
  styleUrl: './timeout-dialog.component.scss',
})
export class TimeoutDialogComponent {
  infoIcon = IconoirInfoCircle;
  readonly data = inject<ResumeData>(MOTIF_MODAL_DATA);
  translatedMessage: string = '';

  constructor(private translate: TranslateService) {
    if (this.data) {
      this.translate
        .get(this.data.description, { timeout: this.data.timeout })
        .subscribe({
          next: (res: string) => {
            this.translatedMessage = res;
          },
          error: (err) => {
            console.error('Error fetching translation:', err);
          },
        });
    }
  }
}
